import './js/functions';
import './js/modules';
import './js/header';
import './js/forms';

window.addEventListener('load', () => {
  global.modules.init();

  initViewDetection({ selector: '.in-view-detect', threshold: 0.01 });

  initAnchors({ selector: 'a[href^="/#"]:not([href="#"])' });
});

// css
import './css/main.css';